import { useEffect, useState } from 'react';
import { usePrimaryEmail } from './api';

const CACHE_KEY = 'k1.forwarding.primaryVerified';

function readCache(): boolean {
  try {
    return sessionStorage.getItem(CACHE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeCache(value: boolean) {
  try {
    sessionStorage.setItem(CACHE_KEY, value ? '1' : '0');
  } catch {
    /* приватный режим — просто работаем без кэша */
  }
}

/**
 * Подтверждён ли основной адрес переадресации. Меню ящика рисуется раньше ответа API,
 * поэтому признак дублируется в sessionStorage: он обновляется при первом входе и после
 * любых изменений в настройках переадресации (мутации инвалидируют `usePrimaryEmail`).
 */
export function useForwardingReady(enabled = true): boolean {
  const { data, isSuccess } = usePrimaryEmail(enabled);
  const [ready, setReady] = useState(readCache);

  useEffect(() => {
    if (!isSuccess) return;
    const verified = data?.status === 'verified';
    writeCache(verified);
    setReady(verified);
  }, [isSuccess, data]);

  return ready;
}
